import React, { useState } from 'react';
import styled from 'styled-components';

import Modal                                              from 'views/components/UI/DefaultModal';
import { Stack, PrimaryButton, DefaultButton, TextField } from 'office-ui-fabric-react';
import { apiTypes }                                       from 'shared/consts/handbooksApiTypes';

interface IProps {
  onSuccess: () => void;
  onCancel: () => void;
  ids: number[];
  apiType: number;
  confirmationCode?: number;
}

const ModalWrap = styled.div`
  padding: 10px 20px;
`;

const DeleteDialog = (props: IProps) => {
  const [confirmationCode, setConfirmationCode] = useState<string | null>(null);

  return (
    <>
      <Modal title="Подтвердить удаление" handleClose={props.onCancel}>
        <ModalWrap>
          {
            props.apiType !== apiTypes.DEFAULT ?
              <>
                <Stack>
                  <p>Для удаления записей с id {props.ids.join(', ')} введите код подтверждения <strong>{props.confirmationCode}</strong>.</p>
                </Stack>
                <Stack style={{marginTop: 5}}>
                  <TextField onChange={(_, newValue) => {
                    if (newValue) {
                      setConfirmationCode(newValue)
                    }
                    
                  }} />
                </Stack>
              </>
              :
              <Stack>
                Действительно хотите удалить записи с id {props.ids.join(', ')}?
              </Stack>
          }
          <Stack
            horizontal
            horizontalAlign={'end'}
            tokens={{ childrenGap: 10 }}
            styles={{ root: { padding: '10px 0' } }}
          >
            <PrimaryButton text="Применить" disabled={props.apiType !== apiTypes.DEFAULT && confirmationCode !== props.confirmationCode?.toString()} onClick={props.onSuccess}  data-qa='applyDeleteBtn' />
            <DefaultButton text="Отмена" onClick={props.onCancel} />
          </Stack>
        </ModalWrap>
      </Modal>
    </>
  );
};

export default DeleteDialog;
